import c from '@/styles/MostRead';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface MostReadSlideImageProps extends ComponentProps<'section'> {
  variant?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  colors?: ClassNameProp<'primary'>;
}

export const MostReadSlideImageComponent: Component<MostReadSlideImageProps> = ({
  className,
  variant,
  size,
  colors,
  children,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const variantClassName = getPropStyles('slide_image_variant', variant, 'default');
  const colorsClassName = getPropStyles('slide_image_colors', colors, 'primary');
  const sizeClassName = getPropStyles('slide_image_size', size, 'default');

  const componentClassName = cn(colorsClassName, variantClassName, sizeClassName, className);

  return (
    <section className={componentClassName} {...props}>
      {children}
    </section>
  );
};
